import ShownAds from 'modules/acount/shownAds';
import Header from 'modules/header/farm/main';

const ShownAdsPage = () => {
  return (
    <>
      <Header title="آگهی‌های نشان شده" />
      <ShownAds app="farm" />
    </>
  );
};

export default ShownAdsPage;
